import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function KubeconNa2024({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.dineWithDevopsMumbai2024', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const teamData = contentData?.teamSection || {};
    const whatsMiddlewareData = contentData?.whatsMiddleware || {};
    const benefitsData = contentData?.benefits || {};
    const suiteData = contentData?.suite || {};
    const getHandsOnData = contentData?.getHandsOn || {};
    const swagData = contentData?.swag || {};
    const missedUsData = contentData?.missedUs || {};
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            return '';
        }
        return String(value);
    };
    
    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <p dangerouslySetInnerHTML={{__html: String(contentData?.description ?? '')}}></p>
                                    
                                    {contentData?.hasTeam && teamData && (
                                        <>
                                            <h4>{String(teamData?.title ?? '')}</h4>
                                            {teamData?.image && (
                                                <img src={String(teamData.image.src)} alt={String(teamData.image.alt)} width={100} height={100}/>
                                            )}
                                            {Array.isArray(teamData?.members) && teamData.members.length > 0 && (
                                                <ul>
                                                    {teamData.members.map((member: any, index: number) => (
                                                        <li key={index}>
                                                            <Link href={String(member?.linkedin ?? '')} target={"_blank"}>{String(member?.name ?? '')}</Link>, {String(member?.role ?? '')}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {whatsMiddlewareData?.title && (
                                        <>
                                            <h4>{String(whatsMiddlewareData.title)}</h4>
                                            <p dangerouslySetInnerHTML={{__html: String(whatsMiddlewareData?.description ?? '')}}></p>
                                        </>
                                    )}

                                    {benefitsData?.title && (
                                        <>
                                            <h4>{String(benefitsData.title)}</h4>
                                            {Array.isArray(benefitsData?.items) && benefitsData.items.map((item: string, index: number) => (
                                                <p key={index}>{String(item)}</p>
                                            ))}
                                        </>
                                    )}

                                    {suiteData?.title && (
                                        <>
                                            <h4>{String(suiteData.title)}</h4>
                                            {Array.isArray(suiteData?.items) && (
                                                <ul>
                                                    {suiteData.items.map((item: any, index: number) => (
                                                        <li key={index}>
                                                            <b>{String(item?.title ?? '')}</b> {String(item?.description ?? '')}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {getHandsOnData?.title && (
                                        <>
                                            <h4>{String(getHandsOnData.title)}</h4>
                                            <p dangerouslySetInnerHTML={{__html: String(getHandsOnData?.description ?? '').replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                        </>
                                    )}

                                    {swagData?.title && (
                                        <>
                                            <h4>{String(swagData.title)}</h4>
                                            {swagData?.image && (
                                                <img src={String(swagData.image.src)} alt={String(swagData.image.alt)} width={100} height={100}/>
                                            )}
                                            <p>{String(swagData?.description ?? '')}</p>
                                        </>
                                    )}

                                    {missedUsData?.title && (
                                        <>
                                            <h4>{String(missedUsData.title)}</h4>
                                            <p dangerouslySetInnerHTML={{__html: String(missedUsData?.description ?? '').replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                        </>
                                    )}

                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Join Middleware at Dine with Devops 2024",
            description:"Meet Middleware at Dine with DevOps 2024 (Nov 22, Mumbai) to see how our observability platform boosts productivity and reduces downtime.",
            ogImage: "/images/events/mw-dine-with-devops.png",
            uri:"/events/dine-with-devops-mumbai-2024/",
            metaTitle:"Join Middleware at Dine with Devops 2024",
            metaDesc:"Meet Middleware at Dine with DevOps 2024 (Nov 22, Mumbai) to see how our observability platform boosts productivity and reduces downtime.",
            metaRobotsNoindex:"index",
            metaRobotsNofollow:"follow",
        },
    }
}
